import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'firstLetterLowercase',
})
export class FirstLetterLowercasePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return value;
    return value.charAt(0).toLowerCase() + value.slice(1);
  }
}
